import React, { useState, useContext, useEffect, useMemo } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { ReportingContext } from "../reporting-context-file";
import styles from "@/page-components/reporting/reporting.module.css";
import { UseGetCustomizableColumns } from "@/services/reporting/get-customizable-column.repo";

const ExportColumns = ({ service, disabledCheckbox }) => {
  const context = useContext(ReportingContext);

  const query = useMemo(
    () => ({
      service: service,
    }),
    []
  );
  const {
    data: columnsList,
    isLoading: columnLoading,
    error,
    refetch,
  } = UseGetCustomizableColumns(query);

  useEffect(() => {
    if (context?.selectedCreateGroupBy) {
      context.setExportType("default");
      context?.setSelectedColumns([]);
    }
  }, [context?.selectedCreateGroupBy]);

  const handleColumnChange = (column) => {
    context?.setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((c) => c !== column)
        : [...prev, column]
    );
  };

  return (
    <div className={styles.export_column}>
      <span className={styles.select_field}>Select Fields</span>

      <Form className={styles.column_options}>
        <div className={styles.export_radio_btn}>
          <div className={styles.export_all_col}>
            <Form.Check
              type="radio"
              id="exportDefault"
              label="Export Default columns"
              name="exportType"
              value="default"
              checked={context?.exportType === "default"}
              disabled={!!context?.selectedCreateGroupBy || disabledCheckbox}
              onChange={() => context?.setExportType("default")}
            />
          </div>
          <div className={styles.export_all_col}>
            <Form.Check
              type="radio"
              id="exportCustom"
              label="Export Selected Columns"
              name="exportType"
              value="custom"
              checked={context?.exportType === "custom"}
              disabled={!!context?.selectedCreateGroupBy || disabledCheckbox}
              onChange={() => context?.setExportType("custom")}
            />
          </div>
        </div>

        {context?.exportType === "custom" && (
          <div className={styles.columns_box}>
            <span className={styles.export_heading}>
              Choose columns to export
            </span>
            <Row>
              {(columnsList?.columns || []).map((col, index) => (
                <Col xs={6} key={col.column_id} className={styles.border_style}>
                  <Form.Check
                    className={styles.checkbox_label}
                    type="checkbox"
                    id={`col-${col.column_id}`}
                    label={
                      <span className={styles.choose_col}>
                        {col.column_name}
                      </span>
                    }
                    checked={context?.selectedColumns.some(
                      (item) => item.column_id === col.column_id
                    )}
                    onChange={() => handleColumnChange(col)}
                    disabled={disabledCheckbox}
                  />
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Form>
    </div>
  );
};

export default ExportColumns;
